import { defineComponent as _defineComponent } from 'vue'
import {onMounted, ref} from 'vue';
import {buyTextParse, publishSingle, releaseWantToBuy} from '@/api/miscellaneous';
import {Toast} from 'vant';
import {base64toFile, captureVideoCover} from '@/libs/utils';
import {upload} from '@/libs/upload';
import {uploadVideo} from '@/libs/uploadVideo';
import VarietiesSearch from '@/components/VarietiesSearch.vue';
import CityPicker from '@/components/CityPicker.vue';
import Specifications from './ReleaseSupply/Specifications.vue';
import userStoreModule from '@/store/modules/user';
import router from '@/router';
import moment from 'moment';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReleaseWantToBuy',
  setup(__props, { expose }) {
  expose();

const text = ref(`例如：求购地径15公分桂花100棵。`);
const stepActive = ref(0);
const textValue = ref(
    // '供应桂花，数量100棵，高度150-200cm，冠幅150- 200cm，胸径40-50cm，供苗地浙江省金华市。供应国槐，数量100棵，高度150-200cm，冠幅150- 200cm，胸径40-50cm，供苗地浙江省金华市',
    '',
);
const list = ref<any[]>([]);
const dataList = ref<any[]>([]);

const uploadIndex = ref(0);
const isShowCityPicker = ref(false);
const cityPickerIndex = ref(0);
const isSpecificationsShow = ref(false);
const specificationsIndex = ref(0);

const isSelectSearch = ref(false);
const selectVarietiesIndex = ref(0);

const defaultPurchasesData = {
    receiptLocation: {
        lat: 0,
        lon: 0,
    },
    categoryId: '',
    minPrice: 0,
    maxPrice: 0,
    title: '',
    payTerm: 1,
    quantity: '',
    profile: '',
    receiptAreaId: '',
    receiptAddress: '',
    expectAreas: [0],
    photos: [],
    specifications: '[]',
    requirePrice: true,
    requirePhotos: true,
    requireAddress: true,
    expires: moment().add(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
};

onMounted(() => {
    let {location = {lat: 0, lon: 0}, shortAddress, areaId} = userStoreModule.userDetail,
        {lat, lon} = location;
    defaultPurchasesData.receiptLocation.lon = lon;
    defaultPurchasesData.receiptLocation.lat = lat;
    defaultPurchasesData.receiptAddress = shortAddress;
    defaultPurchasesData.receiptAreaId = areaId;
});

const parseText = () => {
    // if (!textValue.value) {
    //     stepActive.value = 1;
    //     list.value = [{imgList: []}];
    //     dataList.value = [defaultPurchasesData];
    //     return;
    // }
    releaseWantToBuy({content: textValue.value}).then(res => {
        router.push({name: 'Result', query: {type: 'single'}});
    });
    // buyTextParse({keywords: textValue.value}).then(res => {
    //     let wantToBuyData = (res as any[]).map((el: {name: any; id: any; profile: any}) => {
    //         return {
    //             ...defaultPurchasesData,
    //             ...{
    //                 title: el.name,
    //                 categoryId: el.id,
    //                 profile: el.profile || '',
    //             },
    //         };
    //     });
    //     list.value = (res as any[]).map(el => ({...el, imgList: []}));
    //     stepActive.value = 1;
    //     dataList.value = wantToBuyData;
    // });
};

const imgAfterRead = (file: any) => {
    // dataList.value[cityPickerIndex.value].photos.push(file);
    if (!Array.isArray(file)) file = [file];
    let imgUploads = Promise.all(file.map((el: any) => upload({type: 'purchase', obj: el})));
    let uploading = Toast.loading({
        message: '图片上传中...',
        duration: 0,
        overlay: true,
    });
    imgUploads.then(res => {
        const photos = res.map((el: any) => el.url);
        list.value[uploadIndex.value].imgList = [...list.value[uploadIndex.value].imgList, ...res];
        dataList.value[uploadIndex.value].photos = [...dataList.value[uploadIndex.value].photos, ...photos];
        uploading.clear();
    });
};

const confirmVarieties = (val: any, data: any) => {
    list.value[selectVarietiesIndex.value].attributeObject = val;
    list.value[selectVarietiesIndex.value].id = data.id || data.categoryId;
    list.value[selectVarietiesIndex.value].name = data.name || data.categoryName;
    dataList.value[selectVarietiesIndex.value].categoryId = data.id || String(data.categoryId);
    isSelectSearch.value = false;
};

const confirmSpecifications = (str: string) => {
    dataList.value[specificationsIndex.value].specifications = str;
};

const confirmCity = (val: any[]) => {
    dataList.value[cityPickerIndex.value].receiptAreaId = val[val.length - 1].value as string;
    dataList.value[cityPickerIndex.value].receiptAddress = Array.from(new Set(val.map((el: {label: string}) => el.label))).join('');
};

const onsubmit = (idx: number) => {
    publishSingle(dataList.value[idx]).then(res => {
        list.value[idx].isRelease = true;
        if (list.value.every((el: {isRelease: boolean}) => el.isRelease)) {
            router.push({name: 'Result', params: {type: 'single'}});
        } else {
            Toast.success('发布成功');
        }
    });
};

const __returned__ = { text, stepActive, textValue, list, dataList, uploadIndex, isShowCityPicker, cityPickerIndex, isSpecificationsShow, specificationsIndex, isSelectSearch, selectVarietiesIndex, defaultPurchasesData, parseText, imgAfterRead, confirmVarieties, confirmSpecifications, confirmCity, onsubmit, onMounted, ref, buyTextParse, publishSingle, releaseWantToBuy, Toast, base64toFile, captureVideoCover, upload, uploadVideo, VarietiesSearch, CityPicker, Specifications, userStoreModule, router, moment }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})